import {
  SET_YANDEX_DATA_FAILED,
  SET_YANDEX_DATA_REQUEST,
  SET_YANDEX_DATA_SUCCESS,
  GET_YANDEX_DATA_FAILED,
  GET_YANDEX_DATA_REQUEST,
  GET_YANDEX_DATA_SUCCESS,
  ADD_NEW_YANDEX_FAILED,
  ADD_NEW_YANDEX_REQUEST,
  ADD_NEW_YANDEX_SUCCESS,
  ADD_NEW_YANDEX_CSV_FAILED,
  ADD_NEW_YANDEX_CSV_REQUEST,
  ADD_NEW_YANDEX_CSV_SUCCESS
} from "../Actions/YandexActions";

const initialState = {
  loading: false,
  success: false,
  data: [{ cName: [], cID: [], erID: [] }],
};

export const YandexReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_YANDEX_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case SET_YANDEX_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload.data,
      };
    case SET_YANDEX_DATA_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
      };
    case GET_YANDEX_DATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_YANDEX_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
        data: action.payload.data,
      };
    case GET_YANDEX_DATA_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
      };
      case ADD_NEW_YANDEX_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case ADD_NEW_YANDEX_SUCCESS:
        return {
          ...state,
          loading: false,
          success: true,
          data: action.payload.data,
        };
      case ADD_NEW_YANDEX_FAILED:
        return {
          ...state,
          loading: false,
          success: false,
        };
        case ADD_NEW_YANDEX_CSV_REQUEST:
          return {
            ...state,
            loading: true,
          };
        case ADD_NEW_YANDEX_CSV_SUCCESS:
          return {
            ...state,
            loading: false,
            success: true,
            data: action.payload.data,
          };
        case ADD_NEW_YANDEX_CSV_FAILED:
          return {
            ...state,
            loading: false,
            success: false,
          };
    default:
      return state;
  }
};
